import React, { useContext } from 'react';
import { Context } from '../../../store/store';
import { StyledCurrentPageSelect } from './current-page-select.styles';

const CurrentPageSelect = () => {
  const [state, dispatch] = useContext(Context);
  return (
    <form>
      <StyledCurrentPageSelect
        value={state.currentPage + 1}
        onChange={e => {
          e.preventDefault();
          dispatch({
            type: 'SET_CURRENT_PAGE',
            payload: parseInt(e.target.value, 10) - 1,
          });
          dispatch({ type: 'CLOSE_ALL_SIDEBARS' });
        }}
      >
        {Array.from({ length: state.pagesCount }, (_, i) => i + 1).map(page => {
          return (
            <option key={page} value={page}>
              {page}
            </option>
          );
        })}
      </StyledCurrentPageSelect>
    </form>
  );
};

export default CurrentPageSelect;
